import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "thesis/";

// 论文 - 列表
export const thesisPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myThesis", {
           data: _params,
           method: "GET",
         });
       };

// 论文 - 论文选题-分页
export const thesisSubject = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "subject", {
           data: _params,
           method: "GET",
         });
       };
// 论文 - 论文选题-详情
export const thesisView = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "viewSubject", {
           data: _params,
           method: "GET",
         });
       };

// 论文 - 选择论文题目
export const thesisChooseSubject = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "chooseSubject", {
    data: _params,
    method: "POST",
  });
};
// 论文 -  上传开题报告、初稿、复稿和终稿
    //  * @param thesisInfoId 论文ID
    //  * @param type 1-开题报告,2-初稿,3-复稿,4-终稿
export const thesisUpload = (params) => {
          return `${api.url}${_base}uploadThesis`;
       };
// 论文 - 查看论文审核记录-分页
export const thesisAuditRecord = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "auditRecord", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/thesis.js